// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1iuod","content":"LoadingAlert_content__2cLIG"};